module.exports = __webpack_public_path__ + "static/media/weissand.e94fd993.jpg";